// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectCardLayoutNew__rank {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  font-family: Inter, sans-serif;
}

.ProjectCardLayoutNew__rank-value {
  font-weight: 700;
  font-size: 20px;
  color: #FEFEFE;
  margin: 0 8px;
}

.ProjectCardLayoutNew__rank-heart {
  margin: 0 3px;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/projectCard/ProjectCardLayoutNew.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ProjectCardLayoutNew__rank {\n  display: flex;\n  margin-bottom: 8px;\n  align-items: center;\n  font-family: Inter, sans-serif;\n}\n\n.ProjectCardLayoutNew__rank-value {\n  font-weight: 700;\n  font-size: 20px;\n  color: #FEFEFE;\n  margin: 0 8px;\n}\n\n.ProjectCardLayoutNew__rank-heart {\n  margin: 0 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectCardLayoutNew__rank {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  font-family: Inter, sans-serif;
}

.ProjectCardLayoutNew__rank-value {
  font-weight: 700;
  font-size: 20px;
  color: #FEFEFE;
  margin: 0 8px;
}

.ProjectCardLayoutNew__rank-heart {
  margin: 0 3px;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/projectCard/ProjectCardLayoutNew.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ProjectCardLayoutNew__rank {\n  display: flex;\n  margin-bottom: 8px;\n  align-items: center;\n  font-family: Inter, sans-serif;\n}\n\n.ProjectCardLayoutNew__rank-value {\n  font-weight: 700;\n  font-size: 20px;\n  color: #FEFEFE;\n  margin: 0 8px;\n}\n\n.ProjectCardLayoutNew__rank-heart {\n  margin: 0 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
